import styles from './InfoBlueBox.module.scss';

type InfoBlueBoxProps = {
    boxTitle: string;
    description: string;
}

const InfoBlueBox: React.FC<InfoBlueBoxProps> = ({ boxTitle, description }) => {
    return (
        <div className={styles.infoBox}>
            <strong>{boxTitle}</strong>
            <p>{description}</p>
        </div>
    );
};

export default InfoBlueBox;
